import React from 'react';
import { createRoot } from 'react-dom/client';
import axios from 'axios';
import { I18nextProvider } from 'react-i18next';
import { wixAxiosConfig } from '@wix/wix-axios-config';
import i18n from './i18n';
import App from './components/App';

const baseURL = window.__BASEURL__;
const locale = window.__LOCALE__;

wixAxiosConfig(axios, { baseURL });

const root = createRoot(document.getElementById('root')!);
root.render(
  <I18nextProvider i18n={i18n(locale) as any}>
    <App />
  </I18nextProvider>
);
